"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUIEventError = exports.useUndefinedStoreError = exports.ErrorBoundary = void 0;
/**
 * @todo resolve this linting error of no unused vars re: React import.
 */
const react_1 = require("react");
class ErrorBoundary extends react_1.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
        };
    }
    componentDidCatch(error) {
        // const { logType } = this.props;
        this.setState({ error });
        // if (logger) {
        //   logger(error, logType);
        // }
    }
    render() {
        const { children, render } = this.props;
        const { error } = this.state;
        if (error) {
            return render();
        }
        return children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
function useUndefinedStoreError(condition, component) {
    if (!condition) {
        throw new Error(`[Video]: Undefined store observable(s) and/or method(s) at ${component}`);
    }
}
exports.useUndefinedStoreError = useUndefinedStoreError;
function useUIEventError(eventFunction, component) {
    const [error, setError] = (0, react_1.useState)(null);
    // if (eventFunction == null) {
    //   return;
    // }
    const errorHandledFunction = (...args) => {
        if (eventFunction != null) {
            try {
                eventFunction(...args);
            }
            catch (e) {
                setError(e);
            }
        }
    };
    (0, react_1.useEffect)(() => {
        if (error instanceof Error && eventFunction != null) {
            const functionName = eventFunction.name || "undefined function";
            throw new Error(`[Video]: ${error.name} ${error.message} in ${functionName} at ${component}.`);
        }
    }, [component, error, eventFunction]);
    return errorHandledFunction;
}
exports.useUIEventError = useUIEventError;
//# sourceMappingURL=index.js.map